const actions = {
  ADD: 'bbs/ADD',
  UPDATE: 'bbs/UPDATE',
  DELETE: 'bbs/DELETE',
}

export default actions
